const dataHelper = {};

dataHelper.stokePairs = async (fetchWrapper, key, value) => {
    key = key || 'stock_id';
    value = value || 'name';
    let pairs = {};
    try {
        await fetchWrapper.post('api/stock').then((response) => {
            const result = response.data.data;
            if(result){
                result.forEach(row => {
                    pairs[row[key]] = row[value]
                });
            }
        })
    } catch (error) {
        console.log(error);
    }
    return pairs;
}

export default {
    install: (app) => {
        app.config.globalProperties.$dataHelper = dataHelper; 
    },
};